import type { ActivityEntry } from '@/lib/contract';
import { formatDay } from '@/lib/format';
import { cn } from '@/lib/cn';

const TONE_CLASS: Record<ActivityEntry['tone'], string> = {
  neutral: 'bg-muted',
  pass: 'bg-pass',
  warn: 'bg-warn',
  danger: 'bg-danger'
};

/** The "Recent activity" feed: mono date gutter, dot, sans text. */
export function ActivityList({ entries, className }: { entries: ActivityEntry[]; className?: string }) {
  return (
    <ul className={cn('grid gap-0', className)}>
      {entries.map(entry => (
        <li key={entry.id} className="flex items-center gap-4 py-2.5">
          <span className="w-12 shrink-0 font-mono text-[10px] tracking-[0.1em] text-dim uppercase">
            {formatDay(entry.occurred_at)}
          </span>
          <span className={cn('size-1.5 shrink-0 rounded-full', TONE_CLASS[entry.tone])} />
          <span className="text-[13px] text-foreground">{entry.text}</span>
        </li>
      ))}
    </ul>
  );
}
